var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBoxShadow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-1376.000000, -731.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content-options",
    transform: "translate(653.000000, 665.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(65.000000, 57.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(490.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-box-shadow",
    transform: "translate(168.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "currentColor",
    x: 0,
    y: 0,
    width: 14,
    height: 14,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.25,10.7 L7,14 L13,14 C13.5522847,14 14,13.5522847 14,13 L14,7 L10.65,3.25 L3.25,10.7 Z",
    id: "Path-3",
    fill: "#363971",
    opacity: 0.400000006
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#363971",
    x: 3,
    y: 3,
    width: 8,
    height: 8,
    rx: 1
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBoxShadow);
export default __webpack_public_path__ + "static/media/icon-box-shadow.654672d31916843682f6a8e98a5d58fa.svg";
export { ForwardRef as ReactComponent };